/**
 * UUID generation utility using the standard uuid package.
 * Provides consistent UUID generation across the application.
 */
import { v4 as uuidv4 } from 'uuid'

/**
 * Generate a UUID v4 string using the standard uuid package
 */
export function generateUUID(): string {
  return uuidv4()
}

/**
 * Generate a short ID for request tracking (8 characters)
 * Uses standard UUID v4 but returns a shorter identifier
 */
export function generateRequestId(): string {
  const fullUuid = generateUUID()
  // Return first 8 characters for shorter request IDs
  return fullUuid.substring(0, 8)
}
